import Axios from "axios"

export default {
    login(data){
        console.log('asdas',data)
        return Axios.post("/management/auth/login", data)
    }
}